<div class="app">
  <div class="app__inner" [class.anim--in]="loading$()" [@fadeAnimation]="getRouteAnimationState(outlet)">
    @if (loaded$()) {
      <app-topbar
        (toggleOverlay)="toggleMenu()"
        (closeOverlay)="closeMenu()"
        (openOverlay)="openMenu()"
        [menuActive]="menuOpen$()"
        [menuTheme]="menuTheme$()"
        [searchActive]="searchActive()"
        [menu]="('main-menu' | fromMenu)?.error ? [] : ('main-menu' | fromMenu)"
        [metaMenu]="('meta-menu' | fromMenu)?.error ? [] : ('meta-menu' | fromMenu)"
        [theme]="theme$()"
        [themeLogo]="themeLogo$()"
        [title]="activeLandingPage$()?.segment?.title || activePortal$()?.title || 'Hedon Zwolle'"
        (openCookiePreferences)="openCookiePreferences()"
      >
        <!--[activePortal]="activePortal$()"
        [activeSegment]="activeLandingPage$()?.segment || null"-->
        @if (activePortal$()?.partners?.length) {
          <app-partner-list partner-list [partners]="activePortal$()?.partners"></app-partner-list>
        }
        @if ((activePortal$()?.socialChannels || []).length) {
          <app-social-channel-buttons social-list [channels]="activePortal$()?.socialChannels || []"></app-social-channel-buttons>
        }
      </app-topbar>
    }

    <div class="app__router" id="content">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>

    @if (loaded$()) {
      <app-footer
        class="d-block section-outset-t"
        (openCookiePreferences)="openCookiePreferences()"
        [domain]="domainName"
        [portals]="switcherPortals$()"
        [menu]="('footer-menu' | fromMenu)?.error ? [] : ('footer-menu' | fromMenu)"
        [socials]="activePortal$()?.socialChannels || []"
        [activePortal]="activePortal$()"
      ></app-footer>
    }
  </div>

  <app-loader-indicator [loading]="loading$()"></app-loader-indicator>

  @defer (on idle) {
    @if (loaded$()) {
      <fstr-cookie-notice
        [title]="'cookie-titel' | fromDictionary"
        [text]="'cookie-tekst' | fromDictionary"
        [buttonAccept]="'cookie-accepteer-knop-tekst' | fromDictionary"
        [buttonReject]="'cookie-afwijzen-knop-tekst' | fromDictionary"
      ></fstr-cookie-notice>
    }
  }
</div>
@if (loaded$()) {
  @if (showProgramCTAButton$()) {
    <div class="fixed-cta-button d-sm-none" [class.background-gradient]="!menuOpen$()" [@fadeAnimation]>
      <a class="button button--sm button--primary w-100" [routerLink]="'/'" [fragment]="'programma'" (click)="closeMenu()">
        <span>{{ 'programma-knop-tekst' | fromDictionary }}</span>
      </a>
    </div>
  }

  <!-- FABS -->
  @if (cookiePrefs$()?.marketing) {
    <aside class="fab-list" [class.is--fixed]="fixed()" [class.program-button-spacer]="showProgramCTAButton$()">
      <a class="fab-list__item" href="javascript:void(__robin.show('contact_form'))" [style.--index]="0">
        <span class="fab-slide-button">
          <span class="button button-icon button--primary">
            <fstr-icon anchor="icon-chat"></fstr-icon>
          </span>
          <span class="fab-slide-button__label">{{ 'chat-knop-tekst' | fromDictionary }}</span>
        </span>
      </a>
    </aside>
  }
}
@if (testGridEnabled) {
  <app-grid-overlay></app-grid-overlay>
}

<!--@if (testThemes) {
  <div class="theme-switcher">
    @for (theme of styleguideConfig['themes']; track $index) {
      <button class="button button--primary" (click)="setTheme(theme)">Theme {{ theme }}</button>
    }
  </div>
}-->
